import merge from 'deepmerge';
import configureTooltip from '../tooltip/main';
import chartUtils from '../../../utils/chart-utils';

var getUTCValue = function getUTCValue(date) {
    return Date.UTC(date.getFullYear(), date.getMonth(), date.getDay(), date.getHours(), date.getMinutes(), date.getSeconds());
};

var buildXRangeConfiguration = function buildXRangeConfiguration(XRangeConfig, seriesConfig, seriesDataObj, customConfig) {
    var dataValue = {};
    var data = [];
    var seriesType = 'xrange';
    var ValueFormat = XRangeConfig.ValueFormat;
    var CurrencySymbol = XRangeConfig.CurrencySymbol;
    var fieldName = XRangeConfig.FieldName;
    var startValueField = XRangeConfig.StartValueField;
    var endValueField = XRangeConfig.EndValueField;
    var showLabels = XRangeConfig.ShowLabels;
    var NAME = 'name';
    var X = 'x';
    var X2 = 'x2';
    var Y = 'y';

    seriesDataObj.seriesData && seriesDataObj.seriesData.forEach(function (dataElement) {
        var startValue = dataElement[startValueField];
        var endValue = dataElement[endValueField];
        dataValue = {};
        if (seriesDataObj.typeClass.toLocaleLowerCase() == 'datetime') {
            var startDate = new Date(startValue);
            var endDate = new Date(endValue);
            startValue = getUTCValue(startDate);
            endValue = getUTCValue(endDate);
        }
        dataValue[X] = startValue;
        dataValue[X2] = endValue;
        dataValue[Y] = seriesDataObj.categories.indexOf(dataElement[fieldName]);
        data.push(dataValue);
    });

    return merge({
        data: data,
        type: seriesType,
        dataLabels: {
            enabled: showLabels
        },
        tooltip: {}

    }, customConfig);
};

export default buildXRangeConfiguration;